import { createFileRoute, useParams } from "@tanstack/react-router";
import FactureForm from "@/features/ventes/components/facturation/FactureForm";

function EditFacturePage() {
  const { id } = useParams({ from: Route.id });
  return <FactureForm id={Number(id)} />;
}

export const Route = createFileRoute("/_app/ventes/facturation/$id/edit")({
  staticData: {
    title: "Modifier facture",
    showInBreadcrumb: true,
  },
  component: EditFacturePage,
});
